
export default {
  // component: ActivityLog,
  priority: 1,
  permissions: ["MapConsoleMenu", "Map"],
  name: app.translate("main.Map"),
  icon: "map",
  drawer: true,
  path: "map",
  description: `موقعیت جغرافیایی: این ماژول مکمل اپلیکیشن موبایل کاربران می باشد! علاوه بر اینکه پرسنل در اپلیکیشن موبایل میتوانند گزارش عملکرد خود را مشاهده کنند و یا از طریق تلفن همراه خود اقدام به ثبت درخواست ها یا تأیید درخواست های خود نمایند؛ این گزینه به آنها اجازه میدهد که در موقعیت های مکانی ثبت و تخصیص داده شده، امکان ثبت تردد از طریق تلفن همراه خود داشته باشند!`,
};
